var exports = {
  "_": "AddReason__RmvRvJ",
  "J": "ChangeReason__k9fSlI",
};

module.exports = exports;
